module.exports = __webpack_public_path__ + "img/gift.c13ca106.png";